export function formatPhoneNumber(phoneNumber: string): string {
	if (!phoneNumber) {
		return "";
	}

	const cleaned = phoneNumber
		.replace(/[^\d+]/gu, "") // Remove any non-digit characters except plus sign
		.replace(/(?!^)\+/gu, ""); // Remove any plus signs that are not at the start

	if (cleaned.startsWith("+")) {
		const countryCode = cleaned.slice(0, 4);
		const number = cleaned.slice(4);

		const formatted = number.replace(/(?:\d{3})/gu, "$& ").trim();
		return `${countryCode} ${formatted}`.trim();
	}

	return cleaned.replace(/(?:\d{3})/gu, "$& ").trim();
}
